import React from "react";
import { Link } from "react-router-dom";
import "../Styles/Footer.scss"
// import logo from "../Images/Asset 9.png";
import logo from "../Images/CampConnectSmallLogo.png";
import logo1 from "../Images/facebookLogo.png";
import logo2 from "../Images/instagramLogo.png";
import logo3 from "../Images/twitterLogo.png";

function Footer() {
   return (
      <>
         <div className="footer">
            <div className="footerContainer">
               <div className="socialLinks">
                  <div className="mediaTypes">
                     <a className="facebook" href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                        <img src={logo1} alt="Facebook" />
                     </a>
                     <a className="instagram" href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                        <img src={logo2} alt="Instagram" />
                     </a>
                     <a className="twitter" href="https://twitter.com/" target="_blank" rel="noreferrer">
                        <img src={logo3} alt="Instagram" />
                     </a>
                  </div>
               </div>

               <div className="footerLogo">
                  <Link to={'/'}><img src={logo} alt="AWS logo" /></Link>
               </div>

               <div className="footerAddress">
                  <p>
                     250 Brent Lane <br />
                     Pensacola, FL 32503 <br />
                     850-478-8496 <br />
                  </p>
               </div>
            </div>


         </div>
      </>
   )
}

export default Footer;
